<template>
  <div id="tallasProducto">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-widget title="TALLAS DE PRODUCTO" color="primary darken-4" dark>
            <div slot="widget-content">
              <div>
                <v-btn
                  color="success"
                  dark
                  fab
                  small
                  slot="activator"
                  @click="abrirDialogNuevaTalla"
                >
                  <v-icon dark>add</v-icon>
                </v-btn>
                <form-talla
                  :talla="talla"
                  ref="dialogTallaProducto"
                  @onTallaAdded="onTallaAdded"
                  @onTallaUpdated="onTallaUpdated"
                ></form-talla>
              </div>

              <v-layout row wrap>
                <v-flex lg6 md8 sm12 xs12>
                  <v-card>
                    <v-toolbar card color="white">
                      <v-text-field
                        flat
                        solo
                        prepend-icon="search"
                        placeholder="Búsqueda rápida"
                        v-model="search"
                        hide-details
                        class="hidden-sm-and-down"
                      ></v-text-field>
                      <v-btn icon>
                        <v-icon>filter_list</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-card-text class="pa-0">
                      <template>
                        <v-data-table
                          :headers="headers"
                          :items="tallas"
                          :search="search"
                          :rows-per-page-items="[
                            10,
                            25,
                            50,
                            { text: 'Todos', value: -1 },
                          ]"
                          class="elevation-1 table-styling"
                          item-key="tallaId"
                        >
                          <template slot="items" slot-scope="props">
                            <td>
                              <v-icon color="primary">album</v-icon>
                            </td>
                            <td>TA-{{ zeroFill(props.item.tallaId, 3) }}</td>
                            <td>{{ props.item.tipoProductoDescripcion }}</td>
                            <td class="text-lg-center">
                              {{ props.item.descripcion }}
                            </td>
                            <td class="text-lg-center">
                              {{ props.item.skuAgregado }}
                              <br />
                              <span v-if="props.item.skuAgregado">
                                -Renta:
                                <b
                                  >$
                                  {{
                                    formatMoney(props.item.precioRentaAgregado)
                                  }}</b
                                >
                              </span>
                              <span v-if="props.item.skuAgregado">
                                -Venta:
                                <b
                                  >$
                                  {{
                                    formatMoney(props.item.precioVentaAgregado)
                                  }}</b
                                >
                              </span>
                            </td>
                            <td class="text-xs-right">
                              <v-btn
                                flat
                                icon
                                color="grey"
                                @click="getTalla(props.item.tallaId)"
                              >
                                <v-icon>edit</v-icon>
                              </v-btn>
                              <v-btn
                                flat
                                icon
                                color="grey"
                                :loading="$store.state.loadingDelete.show"
                                @click="deleteTalla(props.item.tallaId)"
                              >
                                <v-icon>delete</v-icon>
                              </v-btn>
                            </td>
                          </template>
                          <v-alert
                            slot="no-results"
                            :value="true"
                            color="error"
                            icon="warning"
                            outline
                            >La búsqueda para "{{ search }}" no encontró
                            registros</v-alert
                          >
                        </v-data-table>
                      </template>
                      <v-divider></v-divider>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </div>
          </v-widget>
        </v-flex>
      </v-layout>
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-container>

    <confirm ref="confirm"></confirm>

    <snack-bar></snack-bar>

    <loading-alert></loading-alert>
  </div>
</template>

<script>
import VWidget from "@/components/VWidget";
import formTalla from "./FormTalla";
import tallaService from "@/services/tallaService";

import confirm from "@/components/dialogs/Confirm";
import loadingAlert from "@/components/LoadingAlert";
import snackBar from "@/components/SnackBar";

export default {
  components: {
    VWidget,
    formTalla,
    confirm,
    loadingAlert,
    snackBar,
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "", align: "center", sortable: false },
        {
          text: "FOLIO",
          align: "left",
          value: "tallaId",
          visibility: "hidden-lg-only",
        },
        {
          text: "TIPO PRODUCTO",
          align: "center",
          value: "tipoProductoDescripcion",
        },
        { text: "DESCRIPCIÓN TALLA", align: "center", value: "descripcion" },
        { text: "SKU AGREGADO", align: "center", value: "skuAgregado" },
        { text: "ACCIONES", value: "acciones", align: "right" },
      ],
      tallas: [],
      talla: {
        tallaId: 0,
        tipoProductoId: 0,
        descripcion: "",
        catalogoRowIdAgregado: null,
        skuAgregado: null,
        precioRentaAgregado: null,
        precioVentaAgregado: null,
      },
    };
  },
  mounted() {
    this.getTallas();
  },
  methods: {
    abrirDialogNuevaTalla() {
      this.$store.state.tituloForm = "AGREGAR TALLA PRODUCTO";
      this.$store.state.iconoForm = "/images/general/agregar-40.png";
      this.$refs.dialogTallaProducto.resetForm();
      this.$refs.dialogTallaProducto.openDialog();
    },
    getTallas() {
      let self = this;
      self.$store.state.loadingInfo.show = true;
      tallaService
        .getAll()
        .then((result) => {
          self.tallas = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    getTalla(tallaId) {
      let self = this;

      self.$store.state.loadingInfo.show = true;
      tallaService
        .get(tallaId)
        .then((result) => {
          self.$store.state.tituloForm = "MODIFICAR TALLA PRODUCTO";
          self.$store.state.iconoForm = "/images/general/actualizar-40.png";
          console.log(result);
          self.$refs.dialogTallaProducto.resetForm();
          self.talla = result;
          self.$refs.dialogTallaProducto.openDialog();
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    deleteTalla(id) {
      let self = this;

      this.$refs.confirm
        .open(
          "ELIMINAR TALLA PRODUCTO",
          "¿Estás seguro de eliminar la talla seleccionada?",
          { color: "red" }
        )
        .then((confirm) => {
          if (confirm) {
            self.$store.state.loadingDelete.show = true;

            tallaService
              .delete(id)
              .then(() => {
                var i = this.tallas.findIndex((obj) => obj.tallaId == id);
                self.tallas.splice(i, 1);

                self.$store.state.snackbar.color = "success";
                self.$store.state.snackbar.text =
                  "Talla de producto eliminada con éxito";
                self.$store.state.snackbar.visible = true;
              })
              .catch((e) => {
                console.log(e);
                self.operationFailed(e);
              })
              .finally(() => {
                self.$store.state.loadingDelete.show = false;
              });
          } else {
            self.$store.state.snackbar.color = "error";
            self.$store.state.snackbar.text = "Operación cancelada";
            self.$store.state.snackbar.visible = true;
          }
        });
    },
    onTallaAdded(talla) {
      this.tallas.push(talla);
    },
    onTallaUpdated(talla) {
      var i = this.tallas.findIndex((obj) => obj.tallaId == talla.tallaId);
      this.tallas.splice(i, 1, talla);
    },
  },
};
</script>
